import { fromJS } from 'immutable';
import R from 'ramda';
import * as constants from './small-template-list-constants';

const initialState = fromJS({
  templates: [],
  loadingTemplates: false,
  templatesForCC: [],
});

export default function smallTemplateList(state = initialState, { type, payload }) {
  switch (type) {
    case constants.GETTING_TEMPLATES:
      return state.set('loadingTemplates', true);
    case constants.POPULATE_REDUCER:
      return fromJS({
        ...payload,
        loadingTemplates: false,
      });
    case constants.CALLING_API:
      return state.update('templates', R.map(template => {
        if (template.get('_id') !== payload.templateId) return template;
        return template.set('callingApi', true);
      }));
    case 'SHOW_CONTRACTING_ERROR_STRING':
      return state.update('templates', R.map(template => template.set('callingApi', false))).set('loadingTemplates', false);
    case 'CLOSE_ADD_EDIT_CONTRACT_DIALOG':
      return initialState;
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/app/stores/contracting/small-template-list/small-template-list-reducer.js